export const SKINS = {
    standard: 'standard',
    standardFilled: 'standardFilled',
    light: 'light',
    lightFilled: 'lightFilled',
    dark: 'dark',
    transparent: 'transparent',
};
export const SIZES = {
    small: 'small',
    medium: 'medium',
    large: 'large',
};
//# sourceMappingURL=CloseButton.constants.js.map